@if (isVisible | async) {
  <a class="d-flex flex-row"
    (click)="filterService.minimizeAll()"
    [routerLink]="[searchLink]"
    [queryParams]="changeQueryParams" queryParamsHandling="merge">
    <span class="filter-value px-1">{{filterValue.label}}</span>
    <span class="float-end filter-value-count ms-auto">
      <span class="badge bg-secondary rounded-pill">{{filterValue.count | dsShortNumber}}</span>
    </span>
  </a>
}
